export enum LotActionEnum {
  PlaceBid = 'place-bid',
  NegotiationsPrice = 'negotiations-price',
  Share = 'share',
  Translate = 'translate',
  AddPhoto = 'add-photo',
  Bids = 'bids',
  Events = 'events',
  Reset = 'reset',
  PurchaseReport = 'purchase-report',
  CreateTranslationRequest = 'create-translation-request',
  GetPhotoRequest = 'get-photo-request',
  Notations = 'notations',
  EditAuctionSheetZones = 'edit-auction-sheet-zones',
  WatchRequest = 'watch-request',
  AddCarInspectionAdmin = 'add-car-inspection-admin',
}
